import { connect } from 'react-redux';
import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';

import {
  selectAreRequiredOptionsIncomplete,
  selectEditedBasketItem,
  selectIsSubmitOptionsFormPending,
  selectOptions,
} from 'src/redux/basket/selectors';
import { submitOptionsForm } from 'src/redux/basket/thunks';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProduct } from 'src/redux/product/selectors';
import type { AppThunkDispatch } from 'src/redux/store';
import type { BasketCTAButtonDispatchProps, BasketCTAButtonStateProps } from './BasketCTAButton';
import { BasketCTAButton } from './BasketCTAButton';
import { MAIN_PAGE_CTA_ID } from './elementIDs';

const mapStateToProps = (state: ReduxApplicationState): BasketCTAButtonStateProps => {
  return {
    editMode: Boolean(selectEditedBasketItem(state)),
    hasOptions: selectOptions(state).length > 0,
    loading: selectIsSubmitOptionsFormPending(state),
    personalisable: selectProduct(state).specialFeatures.personalisable,
    purchasable: selectProduct(state).purchasable,
    requiredFieldsIncomplete: selectAreRequiredOptionsIncomplete(state),
  };
};

const mapDispatchToProps = (dispatch: AppThunkDispatch): BasketCTAButtonDispatchProps => {
  return {
    onAddEditClick: () => dispatch(submitOptionsForm()),
    onBuyGiftCard: (ev: React.MouseEvent) => {
      sendGALinkClickEvent(ev, {
        event: 'custom_event',
        event_action: 'Buy giftcard',
        event_category: 'Product page',
        event_label: 'not set',
      });
    },
    onVisible: () => {
      const ctaButton: HTMLElement | null = document.getElementById(MAIN_PAGE_CTA_ID);

      sendGAEvent({
        event: 'custom_event',
        event_category: 'Product page CTA',
        event_action: 'Impression',
        event_label: ctaButton?.textContent ?? '',
      });
    },
  };
};

export const BasketCTAButtonContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BasketCTAButton);
